import { ApolloProvider } from "@apollo/client";
import { TooltipZoomProvider } from "@outplayed/tooltips";
import adblockDetect from "adblock-detect";
import { initApolloClient } from "api/graphql/apolloInit";
import { LightModeProvider } from "components/LightModeContext";
import { window } from "global";
import { useQueryString } from "hooks/general-hooks";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useGlobal } from "reactn";
import Routes from "router.js";
import { RampContainer } from "./Ads/RampContainer";
import { ResponsiveProvider } from "@outplayed/responsive";
import { WINDOW_BREAKPOINTS_RANGE, DEFAULT_BREAKPOINT } from "lib/constants";
import { UGGLegacyRouteAdapter } from "@ugitgud/legos/context/routing";
import { BannerProvider } from "@ugitgud/legos/components/banner/BannerContainer";

export const WoWContext = React.createContext();

let amplitude;
if (window) {
  amplitude = require("amplitude-js");
}

// if (window) {
//   document.cookie = "ugg_lang=en_US; path=/";
//   document.cookie = "ugg_lang=; expires=Thu, 01-Jan-1970 00:00:01 GMT; path=/";
// }

const AdblockDetector = () => {
  const [adblock, setAdblock] = useGlobal("adblock");
  const [isDetectingAdblock, setDetectingAdblock] = useGlobal("isDetectingAdblock");

  useEffect(() => {
    if (window) {
      adblockDetect((adblockDetected) => {
        setDetectingAdblock(false);
        setAdblock(adblockDetected);
      });
    }
  }, []);

  return null;
};

const UserAuth = (props) => {
  const [authToken] = useGlobal("authToken");
  const [loggingIn, setLoggingIn] = useGlobal("loggingIn");
  // const { loading, data, error } = useQuery(GET_USER_STATE, {skip: !authToken});

  // useEffect(() => {
  //   if (error) {
  //     // If invalid authToken is saved, remove from cache
  //     // if (error.graphQLErrors[0].message === "unauthorized") {
  //       if (window && authToken) {
  //         removeCookie("authToken");
  //         // sessionStorage.removeItem("authToken");
  //         // localStorage.removeItem("authToken");
  //         window.location.reload();
  //       }
  //     // }
  //   }
  //   if (!loading) {
  //     setLoggingIn(false);
  //   }
  // }, [loading])

  return null;
};

const WebPSupport = () => {
  const [isWebP, setIsWebP] = useGlobal("isWebP");

  useEffect(() => {
    (async () => {
      try {
        if (!window) return true;
        if (isWebP !== null && isWebP !== undefined) {
          return isWebP;
        }
        // If the browser doesn't has the method createImageBitmap, you can't display webp format
        if (!self.createImageBitmap) {
          setIsWebP(false);
          return false;
        }

        // Base64 representation of a white point image
        const webpData = "data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoCAAEAAQAcJaQAA3AA/v3AgAA=";

        // Retrieve the Image in Blob Format
        const blob = await fetch(webpData).then((r) => r.blob());

        // If the createImageBitmap method succeeds, return true, otherwise false
        const webP = createImageBitmap(blob).then(
          () => true,
          () => false,
        );

        if (await webP) {
          setIsWebP(true);
        } else {
          setIsWebP(false);
        }
      } catch (error) {}
    })();
  }, []);

  return null;
};

const App = (props) => {
  const { client: passedClient } = props;
  const location = useLocation();
  const [mounted, setMounted] = useState(false);
  const [curClient, setCurClient] = useState(passedClient);
  const [authToken] = useGlobal("authToken");
  const queryParams = useQueryString();
  const { zoom } = queryParams;

  useEffect(() => {
    if (window && amplitude) {
      amplitude.getInstance().init("7eca130169173b8b71bb5a04195be117");
    }
    setMounted(true);
  }, []);

  useEffect(() => {
    // Check if mounted so client doesnt't get re-initialized when passedClient exists
    if (mounted) {
      const apolloState = passedClient.extract();
      setCurClient(initApolloClient(authToken, apolloState));
    }
  }, [authToken, passedClient]);

  // Clear banner cookie on app load, remove once patch has been out for a few days
  // useEffect(() => {
  //   if (window) {
  //     localStorage.removeItem("wowBannerIsOpen");
  //   }
  // }, []);

  return (
    <ApolloProvider client={curClient}>
      <ResponsiveProvider breakpoints={WINDOW_BREAKPOINTS_RANGE} defaultBreakpoint={DEFAULT_BREAKPOINT}>
        {window && <AdblockDetector />}
        {window && <WebPSupport />}
        {window && <UserAuth />}
        {window && <RampContainer />}
        <LightModeProvider>
          <TooltipZoomProvider zoom={zoom}>
            <UGGLegacyRouteAdapter>
              <BannerProvider>
                <Routes />
              </BannerProvider>
            </UGGLegacyRouteAdapter>
          </TooltipZoomProvider>
        </LightModeProvider>
      </ResponsiveProvider>
    </ApolloProvider>
  );
};

export default App;
